import { LitElement, html } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { DsfSkeletonProvider } from "../SkeletonProvider/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfSkeleton = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_enable = false;
  }
  update(changedProps) {
    super.update(changedProps);
    if (this.dsf_enable) {
      DsfSkeletonProvider.enable(this);
    } else {
      DsfSkeletonProvider.disable(this);
    }
  }
  render() {
    return html`<div data-skeleton part="content"><slot></slot></div>`;
  }
};
DsfSkeleton.shadowRootOptions = {
  ...LitElement.shadowRootOptions,
  delegatesFocus: false
};
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSkeleton.prototype, "dsf_enable", 2);
DsfSkeleton = __decorateClass([
  defineElement("dsf-skeleton")
], DsfSkeleton);
export {
  DsfSkeleton
};
